export default __webpack_public_path__ + "static/media/204.7f71aeb4.png";